import config from "config/config";
import { CustomerServerSettings } from "models/customers/customers";
import { apiRequest } from "./apiInterceptor";

export class SettingsAPI {
  static async getSettings(): Promise<CustomerServerSettings> {
    const result = await apiRequest
      .get(config.api.settings.settings);

    return result.body;
  }
}
